import type { ProcedurePayload } from "@/src/api/Tenant";

export type LatLng = {
  lat: number;
  lng: number;
};
/** Alias historyczny — nowy kod używa LatLng. */
export type MapCenter = LatLng;

/** Środek mapy, gdy ani procedura, ani działka nie wskazują innego. */
export const DEFAULT_MAP_CENTER: LatLng = { lat: 51.505, lng: 16.09 };

/**
 * Zakres zoomu widoku OpenLayers. GUGIK ORTO nie serwuje kafli powyżej ~19,
 * dlatego widok jest ograniczony do 19 (getProcedureMapView nadal akceptuje
 * zapisane 0..22 — OlMap przycina do tego zakresu).
 */
export const MAP_MIN_ZOOM = 0;
export const MAP_MAX_ZOOM = 19;
export const clampZoom = (zoom: number): number => Math.min(MAP_MAX_ZOOM, Math.max(MAP_MIN_ZOOM, zoom));

export const DEFAULT_PROCEDURE_MAP_ZOOM = 10;

function toFiniteNumber(value: unknown): number | undefined {
  if (value === null || value === undefined) return undefined;
  if (typeof value === "string" && value.trim() === "") return undefined;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : undefined;
}

export function getProcedureMapView(payload?: ProcedurePayload): {
  center?: MapCenter;
  zoom: number;
} {
  const lat = toFiniteNumber(payload?.mapInitialLat);
  const lng = toFiniteNumber(payload?.mapInitialLng);
  const zoom = toFiniteNumber(payload?.mapInitialZoom);

  const center =
    lat !== undefined && lat >= -90 && lat <= 90 && lng !== undefined && lng >= -180 && lng <= 180
      ? { lat, lng }
      : undefined;

  return {
    center,
    zoom: zoom !== undefined && zoom >= 0 && zoom <= 22 ? zoom : DEFAULT_PROCEDURE_MAP_ZOOM,
  };
}
